import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';

const HOST = environment.serverUrl;
const OCPP_EXPECTED_CONFIGURATION_API_URL = HOST + '/ocpp-expected-configurations';

export interface OcppExpectedConfiguration {
  id?: string;
  key: string;
  value: string;
  vendor?: string;
  model?: string;
  version?: string;
}

@Injectable({ providedIn: 'root' })
export class OcppExpectedConfigurationApiService {

  constructor(private http: HttpClient) { }

  public searchOcppExpectedConfiguration(mode: 'all' | 'profile' = 'all', key?: string, vendor?: string, model?: string, version?: string): Observable<OcppExpectedConfiguration[]> {
    let url = `${OCPP_EXPECTED_CONFIGURATION_API_URL}`;
    const searchParams = [];
    if (mode) {
      searchParams.push(`mode=${encodeURIComponent(mode)}`);
    }
    if (key) {
      searchParams.push(`key=${encodeURIComponent(key)}`);
    }
    if (vendor) {
      searchParams.push(`vendor=${encodeURIComponent(vendor)}`);
    }
    if (model) {
      searchParams.push(`model=${encodeURIComponent(model)}`);
    }
    if (version) {
      searchParams.push(`version=${encodeURIComponent(version)}`);
    }
    if (searchParams.length > 0) {
      url += `?${searchParams.join('&')}`;
    }
    return this.http.get<OcppExpectedConfiguration[]>(url, { responseType: 'json' });
  }

  public updateOcppExpectedConfiguration(id: string, config: OcppExpectedConfiguration): Observable<OcppExpectedConfiguration> {
    return this.http.put<OcppExpectedConfiguration>(`${OCPP_EXPECTED_CONFIGURATION_API_URL}/${id}`, config, { responseType: 'json' });
  }

  public createOcppExpectedConfiguration(config: OcppExpectedConfiguration): Observable<OcppExpectedConfiguration> {
    return this.http.post<OcppExpectedConfiguration>(OCPP_EXPECTED_CONFIGURATION_API_URL, config, { responseType: 'json' });
  }

  public deleteOcppExpectedConfiguration(id: string): Observable<void> {
    return this.http.delete<void>(`${OCPP_EXPECTED_CONFIGURATION_API_URL}/${id}`);
  }
}
